import { render } from "./submitOrder.vue?vue&type=template&id=22af25ce&scoped=true"
import script from "./submitOrder.vue?vue&type=script&lang=js"
export * from "./submitOrder.vue?vue&type=script&lang=js"

import "./submitOrder.vue?vue&type=style&index=0&id=22af25ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22af25ce"

export default script